import React, { Component } from 'react';

class IamExTableRow extends Component {

  state = {

  };

  componentDidMount() {

  };

  render() {

    const timeSinceCreated = Math.floor((Date.now() - new Date(this.props.iamAccessKey.CreateDate).valueOf()) / (1000 * 60 * 60 * 24));
    const timeSinceLastUsed = this.props.iamAccessKey.AccessKeyLastUsed.LastUsedDate ? Math.floor((Date.now() - new Date(this.props.iamAccessKey.AccessKeyLastUsed.LastUsedDate).valueOf()) / (1000 * 60 * 60 * 24)) : 'NA';

    const daysSinceCreated = timeSinceCreated === 0 ? '< 1 Day' : `${timeSinceCreated} Days`;
    const daysSinceLastUsed = timeSinceLastUsed === 'NA' ? 'NA' : timeSinceLastUsed === 0 ? '< 1 Day' : `${timeSinceLastUsed} Days`;

    let createdClass, lastUsedClass;
    let stateClass = 'GreenCell';

    const notes = [];

    if (this.props.iamAccessKey.Status === 'Inactive') {
      createdClass = 'GreyCell';
      lastUsedClass = 'GreyCell';
      stateClass = 'GreyCell';
    } else {
      if (timeSinceCreated < 46) {
        createdClass = 'GreenCell';
      } else if (timeSinceCreated < 90) {
        createdClass = 'YellowCell';
        notes.push('Old. Consider rotating');
      } else {
        createdClass = 'RedCell';
        notes.push('Very old. Requires rotating.');
      }
      if (timeSinceLastUsed === 'NA') {
        lastUsedClass = createdClass;
      } else if (timeSinceLastUsed < 46) {
        lastUsedClass = 'GreenCell';
      } else if (timeSinceLastUsed < 90) {
        lastUsedClass = 'YellowCell';
        notes.push('Rarely used. Consider deactivating.');
      } else {
        lastUsedClass = 'RedCell';
        notes.push('Very rarely used. Requires deactivating/ deleting.');
      }
      if (timeSinceLastUsed === 'NA') {
        lastUsedClass = createdClass;
      };
    };

    return (
      <tr className="IamExTableRowPage">
        <td>
          {this.props.user.UserName}
        </td>
        <td>
          {`${this.props.user.Account}`}
        </td>
        <td>
          {this.props.iamAccessKey.AccessKeyId}
        </td>
        <td className={createdClass}>
          {daysSinceCreated}
        </td>
        <td className={lastUsedClass}>
          {daysSinceLastUsed}
        </td>
        <td className={stateClass}>
          {this.props.iamAccessKey.Status}
        </td>
        <td>
          {notes.join(' ')}
        </td>
      </tr>
    );

  };

};

export default IamExTableRow;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExKeys/iamExKeContent/iamExKeTableRow/iamExKeTableRow.js